<template>
  <v-dialog
    v-if="permissions.orders.actions.new"
    :value="dialog"
    @click:outside.stop="closeDialog(true)"
    @keydown.esc="closeDialog(true)"
    persistent
    fullscreen
    transition="dialog-right-transition"
    content-class="full-screen-dialog"
  >
    <v-card tile class="default-dialog-card">
      <v-toolbar flat class="full-screen-toolbar" :color="get_interface.colors.toolbar">
        <v-btn
          icon
          @click="closeDialog(true)"
          class="noRadius"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <v-icon class="toolbar-icon">mdi-playlist-plus</v-icon>
          {{ `${(id > 0 ? lang.orders.new.edit + ' #' + id : lang.orders.new.title)}` }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                large
                v-on="on"
                @click="reset"
                class="ml-1 noRadius"
              >
                <v-icon>mdi-broom</v-icon>
              </v-btn>
            </template>
            <span>{{ lang.orders.new.reset }}</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                large
                v-on="on"
                @click="saveOrder()"
                :loading="get_interface.loading"
                :disabled="get_interface.loading"
                class="ml-1 noRadius"
              >
                <v-icon>mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>{{ lang.orders.new.save }}</span>
          </v-tooltip>
          <configMenu />
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="fullscreen-scrollbar" v-bar="{ preventParentScroll: true, scrollThrottle: 30 }">
        <div class="order-save">
          <v-form
            ref="SaveForm"
            v-model="valid"
            lazy-validation
          >
            <v-container fluid class="order-container">
              <v-row>
                <v-col cols="12" lg="6" md="12" sm="12" xs="12" class="widget-col">
                  <Order
                    v-model="selected.order"
                    :schedules="selected.schedules"
                    :error="errors.order"
                    @schInput="selected.schedules = $event"
                    :edit_id="id"
                  />
                </v-col>
                <v-col cols="12" lg="6" md="12" sm="12" xs="12" class="pl-1 left-col">
                  <v-row class="order-form-row">
                    <v-col cols="12" class="order-form-col">
                      <v-subheader class="form-subheader">{{ lang.orders.datatable.headers.customer }}</v-subheader>
                      <Customer
                        v-model="selected.customer"
                        :noneRef="selected.ref"
                        :error="errors.customer"
                      />
                    </v-col>
                  </v-row>
                  <v-row class="order-form-row">
                    <v-col cols="12" class="order-form-col">
                      <v-subheader class="form-subheader">{{ lang.orders.new.payment.title}}</v-subheader>
                      <Payment
                        v-model="selected.payment"
                        :subtotal="selected.order.subtotal"
                        :payments="selected.payments"
                        @setPaid="selected.payment.full_paid = $event"
                      />
                    </v-col>
                  </v-row>
                  <v-row class="order-form-row" v-if="((selected.order.list.services || []).length > 0 || (selected.order.list.items || []).length > 0) && permissions.orders.comissions">
                    <v-col cols="12" class="order-form-col">
                      <v-subheader class="form-subheader">{{ lang.orders.new.commissions.title }}</v-subheader>
                      <v-row>
                        <v-col cols="12" class="pa-0">
                          <Comissions
                            v-model="selected.comissions"
                            :schedules="selected.schedules"
                            :services="taxedServices"
                            :items="taxedItems"
                            :edit_id="id"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row class="order-form-row">
                    <v-col cols="12" class="order-form-col">
                      <v-subheader class="form-subheader">{{ lang.orders.new.actions.title }}</v-subheader>
                      <v-row>
                        <!-- <v-col cols="6" class="pa-0">
                          <v-checkbox v-model="order.actions.print" :label="lang.orders.new.actions.print"></v-checkbox>
                        </v-col> -->
                        <v-col cols="6" class="pa-0">
                          <v-select
                            v-model="selected.actions.status"
                            :items="get_global.defaults.options.orders.status"
                            :label="lang.orders.datatable.headers.status"
                            item-value="id"
                            filled
                            dense
                          >
                            <template v-slot:selection="{ selected, item }">
                              <v-chip
                                :input-value="selected"
                                class="chip--select-multi white--text mb-2"
                                :color="item.color"
                              >
                                <v-icon v-text="item.icon" style="font-size: 18px; margin-right: 7px;" />
                                {{ item.title }}
                              </v-chip>
                            </template>
                            <template v-slot:item="{ item }">
                              <v-list-item-icon>
                                <v-icon :class="`${item.color}--text`" v-text="item.icon" />
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title :class="`${item.color}--text`" v-text="item.title" />
                              </v-list-item-content>
                            </template>
                          </v-select>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </div>
      </v-card-text>
      <div style="flex: 7 7 auto;"></div>
    </v-card>
  </v-dialog>
</template>

<script>
import configMenu from '@/templates/main/menus/Config'
import Customer from '@/components/customers/Widget'
import Payment from './templates/payment/Payment'
import Order from './Widget'
import Comissions from './templates/comissions/Comissions'

import defaults from '@/modules/default'
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import save from '@/mixins/defaults/save'

const language = defaults.language

export default {
  components: { configMenu, Customer, Payment, Order , Comissions },
  mixins: [ appdata, utils, save ],
  data () {
    return {
      model: null,
      valid: true,
      errors: {
        customer: false,
        order: false
      },
      rules: language.orders.new.rules
    }
  },
  computed: {
    totalCard () {
      this.selected.payment
      let total = (this.selected.payment.paid || [])
            .filter(paid => paid.type === 3 || paid.type === 4)
            .reduce((acc, curr) => parseFloat((acc + curr.value).toFixed(2)), 0),
          taxes = (this.selected.payment.paid || [])
            .filter(paid => paid.type === 3 || paid.type === 4)
            .reduce((acc, curr) => parseFloat((acc + (curr.value * (curr.tax / 100))).toFixed(2)), 0)
      return { total, taxes }
    },
    totalServices () {
      this.totalCard
      this.selected.order.list.services
      let card = this.totalCard,
          total = (this.selected.order.list.services || [])
            .reduce((acc, curr) => parseFloat((acc + curr.total).toFixed(2)), 0),
          taxes = parseFloat(((card.taxes * total) / card.total).toFixed(2))
      return {
        total,
        taxes: (taxes > 0 ? (card.total > total ? taxes : card.taxes) : 0)
      }
    },
    taxedServices () {
      let totalServ = this.totalServices,
          services = this.selected.order.list.services || []
      return services.map(srv => ({
        ...srv,
        taxes: (totalServ.taxes > 0 ? parseFloat(((totalServ.taxes * srv.total) / totalServ.total).toFixed(2)) : 0)
        // taxes: (card.taxes > 0 ? parseFloat((totalServ.taxes * parseFloat((card.total * srv.total) / totalServ)) / card.total).toFixed(2) : 0)
      }))
    },
    totalItems () {
      this.totalCard
      this.selected.order.list.items
      let card = this.totalCard,
          total = (this.selected.order.list.items || [])
            .reduce((acc, curr) => parseFloat((acc + curr.total).toFixed(2)), 0),
          taxes = parseFloat(((card.taxes * total) / card.total).toFixed(2))
      return {
        total,
        taxes: (taxes > 0 ? (card.total > total ? taxes : card.taxes) : 0)
      }
    },
    taxedItems () {
      let totalItems = this.totalItems,
          services = this.selected.order.list.items || []
      return services.map(srv => ({
        ...srv,
        taxes: (totalItems.taxes > 0 ? parseFloat(((totalItems.taxes * srv.total) / totalItems.total).toFixed(2)) : 0)
        // taxes: (card.taxes > 0 ? parseFloat((totalServ.taxes * parseFloat((card.total * srv.total) / totalServ)) / card.total).toFixed(2) : 0)
      }))
    }
  },
  watch: {
    selected: {
      deep: true,
      handler (newVal) {
        let { customer, order } = { ...newVal },
            order_list = [ ...order.list.items, ...order.list.services ]
        if (customer.confirm) this.errors.customer = false
        if (order_list.length > 0) this.errors.order = false
      }
    },
    'selected.schedules' (newVal) {
      if (newVal.length === 1) this.selected.actions.status = 2
    },
    'selected.payment.full_paid' (newVal) {
      let schedules = this.selected.schedules || []
      if (schedules.length > 0 && !!newVal) this.selected.actions.status = 7
    },
    '$route.params' () {
      this.loadRepeat()
    }
  },
  methods: {
    loadRepeat () {
      var repeat = (typeof this.$route.params.repeat !== 'undefined' ? this.$route.params.repeat : false),
          blank = { ...defaults.blank.order }

      if (repeat) {
        blank.customer = { ...repeat.customer }
        blank.payment = { ...repeat.payment }
        blank.order = { ...repeat.order }
        //console.log('to repeat', blank)
        setTimeout(() => {
          this.selected = { ...blank }
        }, 400);
      }
    },
    validate_ () {
      let { customer, order } = { ...this.selected },
          order_list = [ ...order.list.items, ...order.list.services ],
          errors = []
      this.errors = {
        customer: false,
        order: false
      }
      if (!customer.confirm) {
        this.errors.customer = true
        errors.push('')
      }
      if (order_list.length === 0) {
        this.errors.order = true
        errors.push('')
      }
      console.log('errors', errors)
      return (errors.length === 0) || false
    },
    saveOrder () {
      if (this.$refs.SaveForm.validate() && this.validate_()) {
        let save = JSON.parse(JSON.stringify({ ...this.selected }))
        // console.log('saveOrder', save)
        save.order.list.items = (save.order.list.items || [])
          .map(item => {
            delete item.photo
            return item
          })
        save.schedules = (save.schedules || [])
          .map(sch => {
            sch.selected = (sch.selected || [])
              .map(std => {
                std.root = sch.UUID
                std.employees = (std.employees || [])
                  .map(emp => {
                    if (emp !== null) {
                      return (typeof emp === 'object' ? emp.id : emp)
                    }
                  })
                delete std.av_employees
                return std
              })
            return sch
          })

        console.log('save order', save)
        // console.log('save order Json', JSON.stringify(save))
        this.$store.dispatch('saveData', { page: 1, data: save, item: this.id })
      }
    },
    reset () {
      this.selected.order.list = []
      this.selected.total = 0
      this.$refs.SaveForm.reset()
    }
  },
  created () {
    // this.selected.delivery_fee = this.get_options.delivery_fee
    this.loadRepeat()
  }
}
</script>

<style src="./styles/save.scss" lang="scss"></style>
<style scoped src="./styles/index.css"></style>

